/* ==========================================================================
   THE RING AUTHORITY: SETTINGS
   ==========================================================================

   Shopify version for:
   Custom Ring Canvas Landing Page

   IMPORTANT:
   Only edit the values mentioned in each section.
   Keep quotation marks and commas intact.
   ========================================================================== */

window.TRA_CONFIG = {


  /* ------------------------------------------------------------------
     1. LEAD FORM / WEBHOOK
     ------------------------------------------------------------------

     The landing page enquiry form will send leads to this URL.

     Leave blank until the actual webhook has been created and tested.
     We can connect Zapier, Make, Formspree, or another approved endpoint
     later.

     Example:
     LEAD_WEBHOOK_URL: "https://hooks.zapier.com/hooks/catch/1234567/abcdef/",
  */

  LEAD_WEBHOOK_URL: "",


  /* Some webhook providers require no-cors mode.
     Keep false unless the webhook service specifically requires it. */

  WEBHOOK_NO_CORS_MODE: false,


  /* ------------------------------------------------------------------
     2. WHATSAPP
     ------------------------------------------------------------------

     Enter the WhatsApp number in international format.

     Digits only:
     No +
     No spaces
     No brackets
     No leading zero

     Example:
     Australian 0412 345 678 = "61412345678"

     Keep YOUR_NUMBER_HERE until the correct business number
     is confirmed.
  */

  WHATSAPP_NUMBER: "YOUR_NUMBER_HERE",

  WHATSAPP_MESSAGE:
    "Hi, I would like a mockup and quote for a custom ring canvas.",


  /* ------------------------------------------------------------------
     3. GOOGLE TRACKING
     ------------------------------------------------------------------

     IMPORTANT FOR SHOPIFY:

     Do not enter random or unverified IDs here.

     The Ring Authority Shopify store already has Google-related tracking
     running at store level. We will review this landing page separately
     before enabling any additional direct tracking here to avoid duplicate
     page views or conversions.

     Leave these placeholders for now.
  */


  /* Google Tag Manager */

  GOOGLE_TAG_MANAGER_ID: "GTM-XXXXXXX",


  /* Google Ads */

  GOOGLE_ADS_CONVERSION_ID: "AW-XXXXXXXXX",

  GOOGLE_ADS_CONVERSION_LABEL: "XXXXXXXX",


  /* Google Analytics 4 */

  GA4_MEASUREMENT_ID: "G-XXXXXXXXXX",


  /* ------------------------------------------------------------------
     4. TRUST CLAIMS
     ------------------------------------------------------------------

     These remain disabled until the client confirms the claims.
  */


  /* "Trusted by 200+ gyms..." claim */

  SHOW_TRUST_CLAIM: false,

  TRUST_CLAIM_TEXT:
    "Trusted by 200+ gyms and promotions worldwide",


  /* Safe fallback without a numeric claim */

  SHOW_TRUST_FALLBACK: false,

  TRUST_FALLBACK_TEXT:
    "Supplying custom ring surfaces to gyms, promotions and event organisers.",


  /* ------------------------------------------------------------------
     5. TESTIMONIALS
     ------------------------------------------------------------------

     Keep disabled until genuine client testimonials are supplied.
  */

  SHOW_TESTIMONIALS: false,

  TESTIMONIALS: [

    /*
    Example:

    {
      quote: "Excellent quality and service.",
      name: "Client Name",
      org: "Gym Name"
    },

    */

  ],


  /* ------------------------------------------------------------------
     6. SHOPIFY PAGE SETTINGS
     ------------------------------------------------------------------ */


  /* Shopify Thank You page

     We changed the original static:

     thank-you.html

     to the Shopify page URL:
  */

  THANK_YOU_URL: "/pages/thank-you",


  /* Privacy Policy

     We will connect the store's actual privacy-policy URL
     once we confirm which policy page should be used.
  */

  PRIVACY_URL: "",


  /* Maximum artwork/file attachment size in MB */

  MAX_UPLOAD_MB: 10


};